import React, { useEffect, useState } from "react";
import "./index.css";
import { useLoad } from "../../context";
import ApiServices from "../../services/apiServices";
export default function Regulamento() {
  const { setLoad } = useLoad();

  const [regulamento, setRegulamento] = useState([]);
  async function fnRegulamento() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet("regulamento2/ativo");
      setRegulamento(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnRegulamento();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps


  // <div className='resposta' dangerouslySetInnerHTML={{ __html: faq.Texto }} />

  return (
    <div className="container">
      {regulamento ? (
        <div>
          <h4 className="regulamentoTitulo mt-5">{regulamento.titulo}</h4>
          <div className="regulammentoMensagem">
            <div
              dangerouslySetInnerHTML={{
                __html: regulamento?.mensagem,
              }}
            />
          </div>
        </div>
      ) : (
        <div>Regulamento não disponível</div>
      )}
    </div>
  );
}
